import {useContext, useEffect, useState} from 'react'
import {Button} from 'react-bootstrap'
import {downloadFile, getReports} from '../../../../../shared/actions/CompanyReports'
import {RuntimeContext} from '../../../../../../common/RuntimeContext';
import CompanyReportingFailedModal from './CompanyReportingFailedModal';
import {VerbFetch} from '../../../../../shared/VerbFetch';
import LoadingIndicator from '../../../../../shared/components/LoadingIndicator';
import ActiveListener from '../../../../../shared/components/ActiveListener'

const CompanyReporting = () => {
    const [isOpen, setIsOpen] = useState(true);
    const [isError, setIsError] = useState(false);
    const [type, setType] = useState('');
    const [popularReportStatus, setPopularReportStatus] = useState('');
    const [learnerReportStatus, setLearnerReportStatus] = useState('');
    const [isActiveListenerEnabled, setIsActiveListenerEnabled] = useState(false);
    const [response, setResponse] = useState([]);

    const {pathsWeb} = useContext(RuntimeContext);

    const baseUrl = `${pathsWeb.adminServerUrl}/reports/status`;
    let downloadURL = `${pathsWeb.adminServerUrl}/reports/download?reportName=`;
    const [isLoading, SetIsLoading] = useState(true);

    useEffect(() => {
        getReports({
            type: 'status',
            pathsContext: pathsWeb,
        }).then((res) => {
            SetIsLoading(false);
            setResponse(res);
            res && res.map((o, i) => {
                o['reportName'] == 'popularOnPaths' && setPopularReportStatus(o['status'])
                o['reportName'] == 'learnerProgress' && setLearnerReportStatus(o['status'])
            })
        }).catch((err) => {
            SetIsLoading(false);
        })

        return () => {
            setIsActiveListenerEnabled(false);
        };
    }, [])

    const getReportOnClick = (type) => {
        setType(type);

        getReports({
            type,
            pathsContext: pathsWeb,
        }).then((res) => {
            res?.reportType == 'popularOnPaths' && setPopularReportStatus(res?.status)
            res?.reportType == 'learnerProgress' && setLearnerReportStatus(res?.status)
            setResponse(res);
            setIsActiveListenerEnabled(true);
        }).catch(err => {
            setIsError(true);
        });
    }

    const handleModalSubmit = (type) => {
        setIsOpen(false);
        getReportOnClick(type);
    }

    const handleDownloadLink = (type) => {
        try {
            VerbFetch(`${downloadURL}${type}`, {returnWholeResponse: true}).then(async res => {
                if (res.status !== 200) {
                    setIsError(true);
                    setIsOpen(true);
                    return;
                }
                const stream = res.body;
                const textDecoder = new TextDecoder();

                const reader = stream.getReader();
                let streamedData = '';
                while (true) {
                    const {done, value} = await reader.read()
                    if (done) break;

                    streamedData += textDecoder.decode(value);
                }
                let fileName;
                for (let header of res.headers.entries()) {
                    if (header[0] === 'content-disposition') {
                        fileName = header[1].split('filename=')[1].split(';')[0];
                    }
                }
                if (fileName) {
                    downloadFile(streamedData, fileName);
                }
            }).catch(err => {
                setIsError(true);
                setType(type);
                setIsOpen(true);
            });
        } catch {
            setIsError(true);
            setType(type);
            setIsOpen(true);
        }
    }

    const handleOnSuccess = (data) => {
        if (data.length === 0) {
            setIsActiveListenerEnabled(false);
            return;
        }

        data.map((o, i) => {
            o['reportName'] === 'popularOnPaths' && setPopularReportStatus(o['status'])
            o['reportName'] === 'learnerProgress' && setLearnerReportStatus(o['status'])
        });
        let disableApiCall = data.some(item => !item.status || (item.status.toLowerCase() !== 'completed' && item.status.toLowerCase() !== 'error') );
        setIsActiveListenerEnabled(disableApiCall);
    }

    const handleOnError = (error) => {
        setIsActiveListenerEnabled(false);
    }

    useEffect(() => {
        if (response.length !== 0) {
            if ((popularReportStatus === '' && learnerReportStatus === '') || (popularReportStatus.toLowerCase() === 'completed' && learnerReportStatus.toLowerCase() === 'completed')) {
                setIsActiveListenerEnabled(false);
            } else if ((popularReportStatus === '' && learnerReportStatus.toLowerCase() === 'completed') || (popularReportStatus.toLowerCase() === 'completed' && learnerReportStatus === '')) {
                setIsActiveListenerEnabled(false);
            } else {
                setIsActiveListenerEnabled(true);
            }
        }
    }, [popularReportStatus, learnerReportStatus]);

    return (
    <div className='mb-5'>
        <p className='cr_desc'>Use Paths reporting to understand how your leaders and employees are engaging with
            Paths.</p>
        <p className='cr_sub-desc'> Click on “New Report” to download a CSV file that can be opened using a
            spreadsheet like Microsoft Excel or Google Sheets. Paths data is updated every day at 5 a.m. ET.</p>
        <ActiveListener
            url={baseUrl}
            method="GET"
            frequency={2500} //2.5 seconds in miliseconds
            onSuccess={(data) => handleOnSuccess(data)}
            onFailure={(error) => handleOnError(error)}
            isActivated={isActiveListenerEnabled}
        />
        {isLoading ? (
                <div className={'cr_row'}>
                    <LoadingIndicator className={'report-loading'}/>
                </div>
            ) :
            <div className='grid'>
                <div className='row cr_row'>
                    <div className='col-8'>
                        <p className='m-0 cr_row_heading'>Learner Progress Report</p>
                        <p className='m-0'>Use this report to monitor individual and team progress, assignments, and
                            completions.</p>
                    </div>
                    <div className='col-4'>
                        <Button className={`cr_btn cr_primary_btn ${learnerReportStatus == '' || learnerReportStatus == 'ERROR' ? '' : 'disabled'}`}
                                onClick={() => getReportOnClick('learnerProgress')}>New Report</Button>
                    </div>
                </div>
                <div className='row'>
                    {
                        (learnerReportStatus == 'REQUESTED' || learnerReportStatus == 'IN_PROGRESS') &&
                        <div className='col-12 cr_text_with_icon'>
                            <i className={' fa fa-spinner fa-spin icon'}/>
                            <p className='m-0 desc requested'>Please give us a few minutes to generate this report.
                                When it is ready, a link will automatically appear for you to download the
                                report.</p>
                        </div>
                    }
                    {
                        learnerReportStatus == 'ERROR' &&
                        <div className='col-12 cr_text_with_icon'>
                            <i className={'fa fa-info icon'}/>
                            <p className='m-0 desc error'>We’re sorry, there was an error with your last request.
                                Please try
                                again or refresh the page. If you need additional help, ask an authorized contact to
                                submit a work order to Paycor.</p>
                        </div>
                    }
                    {
                        learnerReportStatus == 'COMPLETED' &&
                        <div className='col-12 cr_text_with_icon'>
                            <i className={'fa fa-check icon'}/>
                            <p className='m-0 desc success'>Your report is ready! This link will expire at 5 a.m.
                                ET. <a
                                    onClick={() => handleDownloadLink('learnerProgress')} className='download-link'>Download
                                    Report</a></p>
                        </div>
                    }
                </div>
                <div className='row cr_row'>
                    <div className='col-8'>
                        <p className='m-0 cr_row_heading'>Popular on Paths Report</p>
                        <p className='m-0'>Use this report to see which Paths are started and completed the
                            most often.</p>
                    </div>
                    <div className='col-4'>
                        <Button className={`cr_btn cr_primary_btn ${popularReportStatus == '' || popularReportStatus == 'ERROR' ? '' : 'disabled'}`}
                                onClick={() => getReportOnClick('popularOnPaths')}>New Report</Button>

                    </div>
                </div>
                <div className='row'>
                    {
                        (popularReportStatus == 'REQUESTED' || popularReportStatus == 'IN_PROGRESS') &&
                        <div className='col-12 cr_text_with_icon'>
                            <i className={'fa fa-spinner fa-spin icon'}/>
                            <p className='m-0 desc requested'>Please give us a few minutes to generate this report.
                                When it is ready, a link will automatically appear for you to download the
                                report.</p>
                        </div>
                    }
                    {
                        popularReportStatus == 'ERROR' &&
                        <div className='col-12 cr_text_with_icon'>
                            <i className={'fa fa-info icon'}/>
                            <p className='m-0 desc error'>We’re sorry, there was an error with your last request.
                                Please try
                                again or refresh the page. If you need additional help, ask an authorized contact to
                                submit a work order to Paycor.</p>
                        </div>}
                    {
                        popularReportStatus == 'COMPLETED' &&
                        <div className='col-12 cr_text_with_icon'>
                            <i className={'fa fa-check icon'}/>
                            <p className='m-0 desc success'>Your report is ready! This link will expire at 5 a.m.
                                ET. <a
                                    onClick={() => handleDownloadLink('popularOnPaths')} className='download-link'>Download
                                    Report</a></p>
                        </div>
                    }
                </div>
                <div className='row'>
                    <div className='col-12 readmore'>
                        <p className='m-0 desc'>Learn more about Paths reporting in our <a
                            href='https://knowledge.paycor.com/2604432-what-reporting-is-available-for-paths' target="_blank"
                            className='link'>Knowledge Base</a>.</p>
                    </div>
                </div>
            </div>
        }
        {isError && <CompanyReportingFailedModal isOpen={isOpen} onSubmit={handleModalSubmit} type={type}/>}
    </div>
)
}

export default CompanyReporting